module.exports = __webpack_public_path__ + "static/media/Delorean-by-Visualdon.57979cb1.gif";